// Pure tour configuration — no DOM, no driver.js. Copy follows the
// plain-language rules in nib-website-frontend/TOUR-GUIDE.md: short
// sentences, everyday words, conversational.

export interface TourStep {
  target: string | null; // CSS selector; null = centered popover
  title: string;
  content: string;
  side?: "top" | "bottom" | "left" | "right";
}

export function buildDashboardSteps(opts: { hasChatling: boolean }): TourStep[] {
  const steps: TourStep[] = [
    {
      target: null,
      title: "Welcome to your NIB portal",
      content:
        "Let's take a quick look around. You can leave the tour at any time — click the X or press Esc.",
    },
    {
      target: '[data-tour="main-nav"]',
      title: "Your main menu",
      content: "Use these links to move between Cards and Claims.",
      side: "bottom",
    },
    {
      target: '[data-tour="onboarding-checklist"]',
      title: "Getting started",
      content:
        "This list shows what to set up first — your profile, local office, and banking details. Each item links to the right page.",
      side: "bottom",
    },
    {
      target: '[data-tour="nav-claims"]',
      title: "Submit a claim",
      content: "Ready to apply for a benefit? Start here to see and submit claims.",
      side: "bottom",
    },
    {
      target: '[data-tour="user-menu"]',
      title: "Your account",
      content: "Update your details or log out from this menu.",
      side: "bottom",
    },
  ];
  if (opts.hasChatling) {
    steps.push({
      target: null,
      title: "Meet Pinky",
      content:
        "Need help any time? Click the chat bubble in the corner to talk with Pinky, our assistant.",
    });
  }
  steps.push({
    target: '[data-tour="help-button"]',
    title: "Take this tour again",
    content: "Click this button whenever you want a refresher.",
    side: "bottom",
  });
  return steps;
}

export function filterAvailableSteps(
  steps: TourStep[],
  isPresent: (selector: string) => boolean
): TourStep[] {
  return steps.filter((s) => s.target === null || isPresent(s.target));
}

// Offer-vs-not persistence decision, kept pure so the node-env test
// runner can cover it (useTour.ts itself imports DOM/driver.js).
export function shouldOfferTour(state: { completed: boolean }): boolean {
  return !state.completed;
}
